import Masonry from 'masonry-layout';

/**
 * @module News
 */
class News {
    /**
     * @constructor
     * @param {HTMLElement} element
     * @param {object} options
     */
    constructor(element, options) {
        this._element = element;
        this._options = options;
        this._masonry = false;
        this.load();
    }

    /**
     * load
     */
    load() {
        window.addEventListener('resize', evt => this._onResize(evt));
    }

    /**
     * resize event handler
     * @param {HTMLElement} target
     */
    _onResize({ target }) {
        const width = target.innerWidth;
        if (width >= 768 && !this._masonry) {
            this._createMasonry();
        } else if (width <= 768 && this._masonry) {
            this._destroyMasonry();
        }
    }

    /**
     * create masonry
     */
    _createMasonry() {
        this._masonry = new Masonry(this._element, {
            itemSelector: '.news__item',
            gutter: 32
        });
    }

    /**
     * destroy masonry
     */
    _destroyMasonry() {
        this._masonry.destroy();
        this._masonry = false;
    }
}

export default News;
